/**
 * Typed feature-flag dictionary. Defaults are the values a build ships with;
 * a provider (PostHog) can override at runtime. Adding a flag means adding it
 * here — there is no stringly-typed lookup anywhere else.
 */
export const flagDefaults = {
  friends: false,
  library: false,
  groupChat: false,
  handwritingCapture: true,
  audioCues: false,
} as const;

export type FlagName = keyof typeof flagDefaults;
export type Flags = { [K in FlagName]: boolean };

export interface FlagProvider {
  get(name: FlagName): boolean | undefined;
  subscribe?(listener: () => void): () => void;
}

export function resolveFlags(provider?: FlagProvider, overrides: Partial<Flags> = {}): Flags {
  const result = { ...flagDefaults } as Flags;
  for (const name of Object.keys(flagDefaults) as FlagName[]) {
    const remote = provider?.get(name);
    const local = overrides[name];
    result[name] = local ?? remote ?? flagDefaults[name];
  }
  return result;
}
